import { render, staticRenderFns } from "./aviso-mei.vue?vue&type=template&id=46ab53c0&"
import script from "./aviso-mei.vue?vue&type=script&lang=js&"
export * from "./aviso-mei.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports